import React from 'react';
import {reduxForm} from 'redux-form';
import FormField from '../form/form-field';
import SeasonSelect from '../season/season-select';
import TextField from '../form/text-field';
import ImageField from '../form/image-field';
import BaseForm from '../form/base-form';
import LocalizedStrings from '../../localization/strings';
import MenuBuilder from '../menu-builder';
import Button from '../button';
import ExpandableContent from '../../components/expandable-content';
import {validateRequiredFields} from '../../utils/form';
import ColorSelectField from '../form/color-select-field';
import Alert from '../alert';

const fields = [
    'id',
    'about_text',
    'contacts_text',
    'seasonId',
    'logoId',
    'ogImageId',
    'facebook_link',
    'youtube_link',
    'strava_link',
    'instagram_link',
    'title',
    'regulations',
    'insurance_text',
    'insurance_text_in_registration',
    'insurance_text_label',
    'archive_text',

    'about_text_en',
    'contacts_text_en',
    'regulations_en',
    'insurance_text_en',
    'insurance_text_in_registration_en',
    'insurance_text_label_en',
    'archive_text_en',


    'display_news',
    'display_partners',
    'single_event_website',
    'menu',
    'localization_enabled',

    'menu_color',
    'menu_highlight_color',
    'button_color',
    'button_hover_color',

    'fb_pixel_code',
    'google_analytics_code',
    'multiple_stage_display',
    'meta_keywords',
    'meta_description'
];

function validate(values) {
    let errors = {
        _error: null
    };
    errors = validateRequiredFields(values, [
        'seasonId', 'logoId', 'title'
    ], errors);
    return errors;
}

class SettingsForm extends BaseForm {

    render() {
        const {
            submitting,
            error,
            handleSubmit,
            fields: {
                about_text,
                contacts_text,
                seasonId,
                logoId,
                ogImageId,
                facebook_link,
                youtube_link,
              strava_link,
                instagram_link,
                title,
                regulations,
                insurance_text,
                insurance_text_in_registration,
                insurance_text_label,
                archive_text,

                about_text_en,
                contacts_text_en,
                regulations_en,
                insurance_text_en,
                insurance_text_in_registration_en,
                insurance_text_label_en,
                archive_text_en,
                display_partners,
                display_news,
                single_event_website,

                menu,
                localization_enabled,
                menu_color,
                menu_highlight_color,
                button_color,
                button_hover_color,

                fb_pixel_code,
                google_analytics_code,
                multiple_stage_display,

                meta_keywords,
                meta_description

            }
        } = this.props;
        //about_text_en, contacts_text_en, regulations_en, insurance_text_en, insurance_text_in_registration_en, insurance_text_label_en, archive_text_en

        return (
            <div>
                <form onSubmit={handleSubmit(this.submit.bind(this))}>
                    {error && <Alert type="error">{error}</Alert>}

                    <ExpandableContent title={LocalizedStrings.siteConfig} expanded={true}>
                        <FormField label={LocalizedStrings.logo} name="logo" field={logoId}>
                            <ImageField {...logoId}></ImageField>
                        </FormField>

                        <FormField label={LocalizedStrings.title} name="title" field={title}>
                            <input ref="title" placeholder={LocalizedStrings.title} type="text" {...title} />

                        </FormField>

                        <FormField label={LocalizedStrings.season} name="season" field={seasonId}>
                            <SeasonSelect field={seasonId}></SeasonSelect>
                        </FormField>

                        <FormField label={LocalizedStrings.displayNews} name="display_news" field={display_news}
                                   className="checkbox-field">
                            <input type="checkbox" {...display_news} />
                        </FormField>
                        <FormField label={LocalizedStrings.displayPartners} name="display_partners"
                                   field={display_partners} className="checkbox-field">
                            <input type="checkbox" {...display_partners} />
                        </FormField>
                        <FormField label={LocalizedStrings.singleEventWebsite} name="single_event_website"
                                   field={single_event_website} className="checkbox-field">
                            <input type="checkbox" {...single_event_website} />
                        </FormField>
                        <FormField label={LocalizedStrings.multipleStageDisplay} name="multiple_stage_display"
                                   field={multiple_stage_display} className="checkbox-field">
                            <input type="checkbox" {...multiple_stage_display} />
                        </FormField>

                        <FormField label={LocalizedStrings.localizationEnabled} name="localization_enabled"
                                   field={localization_enabled} className="checkbox-field">
                            <input type="checkbox" {...localization_enabled} />
                        </FormField>
                    </ExpandableContent>
                    <ExpandableContent title={LocalizedStrings.seo} expanded={true}>
                        <FormField label={LocalizedStrings.webKeywords} name="keywords" field={meta_keywords}>
                            <input placeholder={LocalizedStrings.webKeywords} type="text" {...meta_keywords} />

                        </FormField>

                        <FormField label={LocalizedStrings.webDescription} name="title" field={meta_description}>
                            <input ref="title" placeholder={LocalizedStrings.webDescription}
                                   type="text" {...meta_description} />

                        </FormField>

                        <FormField label={LocalizedStrings.ogImage} name="ogImageId" field={ogImageId}>
                            <ImageField {...ogImageId}></ImageField>
                        </FormField>
                    </ExpandableContent>

                    <ExpandableContent title={LocalizedStrings.pages} expanded={true}>
                        <fieldset>
                            <legend>{LocalizedStrings.about}</legend>

                            <FormField label={LocalizedStrings.ltLabel} name="about" field={about_text}>
                                <TextField {...about_text}></TextField>
                            </FormField>

                            <FormField label={LocalizedStrings.enLabel} name="about_text_en" field={about_text_en}>
                                <TextField {...about_text_en}></TextField>
                            </FormField>
                        </fieldset>

                        <fieldset>
                            <legend>{LocalizedStrings.contacts}</legend>

                            <FormField label={LocalizedStrings.ltLabel} name="contacts" field={contacts_text}>
                                <TextField {...contacts_text}></TextField>
                            </FormField>
                            <FormField label={LocalizedStrings.enLabel} name="contacts_text_en"
                                       field={contacts_text_en}>
                                <TextField {...contacts_text_en}></TextField>
                            </FormField>
                        </fieldset>

                        <fieldset>
                            <legend>{LocalizedStrings.regulations}</legend>
                            <FormField label={LocalizedStrings.ltLabel} name="regulations" field={regulations}>
                                <TextField {...regulations}></TextField>
                            </FormField>
                            <FormField label={LocalizedStrings.enLabel} name="regulations_en" field={regulations_en}>
                                <TextField {...regulations_en}></TextField>
                            </FormField>
                        </fieldset>

                        <fieldset>
                            <legend>{LocalizedStrings.archive}</legend>

                            <FormField label={LocalizedStrings.ltLabel} name="archive" field={archive_text}>
                                <TextField {...archive_text}></TextField>
                            </FormField>

                            <FormField label={LocalizedStrings.enLabel} name="archive_text_en" field={archive_text_en}>
                                <TextField {...archive_text_en}></TextField>
                            </FormField>
                        </fieldset>
                    </ExpandableContent>
                    <ExpandableContent title={LocalizedStrings.socialMedia} expanded={true}>

                        <FormField label={LocalizedStrings.facebook} name="facebook" field={facebook_link}>
                            <input ref="facebook" placeholder={LocalizedStrings.facebook}
                                   type="text" {...facebook_link}/>
                        </FormField>

                        <FormField label={LocalizedStrings.youtube} name="youtube" field={youtube_link}>
                            <input ref="youtube" placeholder={LocalizedStrings.youtube} type="text" {...youtube_link}/>
                        </FormField>
                      <FormField label={LocalizedStrings.strava} name="strava" field={strava_link}>
                        <input ref="youtube" placeholder={LocalizedStrings.strava} type="text" {...strava_link}/>
                      </FormField>

                        <FormField label={LocalizedStrings.instagram} name="instagram" field={instagram_link}>
                            <input ref="instagram" placeholder={LocalizedStrings.instagram}
                                   type="text" {...instagram_link}/>
                        </FormField>

                    </ExpandableContent>


                    <ExpandableContent title={LocalizedStrings.insurance} expanded={true}>
                        <fieldset>
                            <legend>{LocalizedStrings.insuranceTextInRegistration}</legend>


                            <FormField label={LocalizedStrings.ltLabel} name="instagram"
                                       field={insurance_text_in_registration}>
                                <input ref="insurance_text_in_registration"
                                       type="text" {...insurance_text_in_registration}/>
                            </FormField>

                            <FormField label={LocalizedStrings.enLabel} name="instagram"
                                       field={insurance_text_in_registration_en}>
                                <input ref="insurance_text_in_registration_en"
                                       type="text" {...insurance_text_in_registration_en}/>
                            </FormField>
                        </fieldset>

                        <fieldset>
                            <legend>{LocalizedStrings.insuranceTextLabel}</legend>

                            <FormField label={LocalizedStrings.ltLabel} name="insurance_text_label"
                                       field={insurance_text_label}>
                                <input ref="insurance_text_label" type="text" {...insurance_text_label}/>
                            </FormField>

                            <FormField label={LocalizedStrings.enLabel} name="insurance_text_label_en"
                                       field={insurance_text_label_en}>
                                <input ref="insurance_text_label_en" type="text" {...insurance_text_label_en}/>
                            </FormField>

                        </fieldset>

                        <fieldset>
                            <legend>{LocalizedStrings.insuranceText}</legend>
                            <FormField label={LocalizedStrings.ltLabel} name="insurance_text" field={insurance_text}>
                                <TextField {...insurance_text}></TextField>
                            </FormField>
                            <FormField label={LocalizedStrings.enLabel} name="insurance_text_en"
                                       field={insurance_text_en}>
                                <TextField {...insurance_text_en}></TextField>
                            </FormField>
                        </fieldset>

                    </ExpandableContent>

                    <ExpandableContent title={LocalizedStrings.tracking} expanded={true}>

                        <FormField label={LocalizedStrings.googleAnalyticsCode} name="google_analytics_code" field={google_analytics_code}>
                            <input ref="google_analytics_code" placeholder={LocalizedStrings.googleAnalyticsCode}
                                   type="text" {...google_analytics_code}/>
                        </FormField>

                        <FormField label={LocalizedStrings.facebookPixelCode} name="fb_pixel_code" field={fb_pixel_code}>
                            <input ref="fb_pixel_code" placeholder={LocalizedStrings.facebookPixelCode}
                                   type="text" {...fb_pixel_code}/>
                        </FormField>


                    </ExpandableContent>

                    <ExpandableContent title={LocalizedStrings.menu}>


                        <MenuBuilder {...menu} />


                    </ExpandableContent>

                    <ExpandableContent title={LocalizedStrings.colors}>
                        <div className="form-row">
                            <FormField label={LocalizedStrings.menuColor} name="menu_color" field={menu_color}>
                                <ColorSelectField {...menu_color}/>
                            </FormField>
                            <FormField label={LocalizedStrings.menuHighlightColor} name="menu_highlight_color"
                                       field={menu_highlight_color}>
                                <ColorSelectField {...menu_highlight_color}/>
                            </FormField>
                        </div>
                        <div className="form-row">
                            <FormField label={LocalizedStrings.buttonColor} name="button_color" field={button_color}>
                                <ColorSelectField {...button_color}/>
                            </FormField>
                            <FormField label={LocalizedStrings.buttonHoverColor} name="button_hover_color"
                                       field={button_hover_color}>
                                <ColorSelectField {...button_hover_color}/>
                            </FormField>
                        </div>

                    </ExpandableContent>



                    <div className="actions-row">
                        <Button loading={submitting} submit={true} disabled={submitting} type="primary">
                            {LocalizedStrings.submit}
                        </Button>

                    </div>

                </form>
            </div>
        )
    }
}

export default reduxForm({
    form: 'settings-form',
    fields,
    validate,
    destroyOnUnmount: true
}, state => ({initialValues: state.settings.settings}))(SettingsForm);



// WEBPACK FOOTER //
// ./src/js/components/settings/settings-form.js